module.exports = __webpack_public_path__ + "media/images/emblems/Langenthal-coat_of_arms-ff5faedcb187efe0d0c0eee8d311a013.svg";